module.exports = __webpack_public_path__ + "img/u.d7265416.jpg";